import React from 'react'

import { TypeFormats } from 'utils/format'

import './style.css'

interface ITooltipDeltaProps {
  delta: number
  showText?: boolean
}

const TooltipDelta = ({ delta, showText = true }: ITooltipDeltaProps) => {
  const isPositive = delta >= 0
  const spanClassName =
    delta === 0
      ? undefined
      : `tooltip-delta-label-${isPositive ? 'arrow-up' : 'arrow-down'}`
  const pClassName =
    delta === 0
      ? undefined
      : `tooltip-delta-label-${
          isPositive ? 'delta-positive' : 'delta-negative'
        }`
  return (
    <div className="highcharts-tooltip-label">
      {showText && <p className="highcharts-tooltip-label-key">Change</p>}
      <div className="tooltip-delta-label-arrow-container">
        <span className={spanClassName} />
        <p className={pClassName}>{TypeFormats.PERCENT(delta)}</p>
      </div>
    </div>
  )
}

export default TooltipDelta
